import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';

function AddButton({ onAddSuccess }) {
  const [formData, setFormData] = useState({
    title: '',
    firstName: '',
    middleInitial: '',
    lastName: '',
    role: 'Dental Hygienist' // Pre-selected role as in the image
  });

  const [setIsFormVisible] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveClick = async () => {
    try {
      const response = await axios.post('https://hms.backend.hiragroupcloud.com/api/content', formData);
      alert('Provider details saved successfully!');
      setIsFormVisible(false);

      if (onAddSuccess) {
        onAddSuccess(response.data);
      }

      setFormData({
        title: '',
        firstName: '',
        middleInitial: '',
        lastName: '',
        role: 'Dental Hygienist'
      });
    } catch (error) {
      console.error('Error saving provider:', error);
      alert('Failed to save provider details.');
    }
  };

  return (
    <>
     
      <div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
        <div className="row">
       

          <div className="col-md-10">
            <h3>Add Account Contact</h3>
            <br />
            <h4 style={{ color: "#1E90FF" }}>Provider Details</h4>
            <div style={{ backgroundColor: '#f0f0f0', padding: '20px', borderTop: "3px solid #004aad" }}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  maxWidth: '600px',
                  marginLeft: '0',
                  marginRight: 'auto',
                  fontFamily: 'Arial, sans-serif',
                }}
              >
                {/* Title Field */}
                <div style={{ marginBottom: '15px' }}>
                  <label htmlFor="title" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Title</label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    id="title"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                {/* First Name Field (marked with asterisk) */}
                <div style={{ marginBottom: '15px' }}>
                  <label htmlFor="firstName" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>First Name<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    id="firstName"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                {/* Middle Initial Field */}
                <div style={{ marginBottom: '15px' }}>
                  <label htmlFor="middleInitial" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Middle Initial</label>
                  <input
                    type="text"
                    name="middleInitial"
                    value={formData.middleInitial}
                    onChange={handleInputChange}
                    id="middleInitial"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                {/* Last Name Field (marked with asterisk) */}
                <div style={{ marginBottom: '15px' }}>
                  <label htmlFor="lastName" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Last Name<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    id="lastName"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                {/* Role Field (pre-selected as Dental Hygienist) */}
                <div style={{ marginBottom: '15px' }}>
                  <label htmlFor="role" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>Role</label>
                  <select
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    id="role"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                      height: '35px',
                    }}
                  >
                    <option value="Dental Hygienist">Dental Hygienist</option>
                    <option value="Dental Provider">Dental Provider</option>
                    <option value="Dental Student Provider">Dental Student Provider</option>
                    <option value="Dental Faculty Provider">Dental Faculty Provider</option>
                    <option value="Dental Assistant">Dental Assistant</option>
                    <option value="Clinic Director">Clinic Director</option>
                    <option value="Office Manager">Office Manager</option>
                    <option value="Front Desk">Front Desk</option>
                    <option value="BookKeeper">BookKeeper</option>
                    <option value="Practice Mini-Lab Technician">Practice Mini-Lab Technician</option>
                    <option value="Administrator">Administrator</option>
                  </select>
                </div>

                {/* Save Button */}
                <Button
                  style={{
                    backgroundColor: '#004aad',
                    borderColor: '#004aad',
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginTop: '10px',
                  }}
                  onClick={handleSaveClick}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div><br /><br />
      
     
    </>
  );
}

export default AddButton;